import { FunctionalComponent, h } from "preact"
import { ImageContent, ProcessStepStyled } from "./process-step.style"

export interface ProcessStepProps {
  title: string,
  subtitle: string,
  description: h.JSX.Element | string,
  image: {
    element: h.JSX.Element,
    width: string,
    height: string,
    bgColor: string,
    title?: string,
    responsive: {
      sm: {
        width: string,
        height: string
      }
    }
  }
}
export const ProcessStep: FunctionalComponent<ProcessStepProps> = ({ title, subtitle, description, image }) => {
  return (
    <ProcessStepStyled>
      <div class="process-step-info">
        <span class="title">{title}</span>
        <span class="subtitle">{subtitle}</span>
        <p>{description}</p>
      </div>
      <ImageContent
        className='imagen-content'
        bgColor={image.bgColor}
        imgWidth={image.width}
        imgHeight={image.height}
        imgWidthSm={image.responsive.sm.width}
        imgHeightSm={image.responsive.sm.height}>
        {image.element}
        <span>{image.title}</span>
      </ImageContent>
    </ProcessStepStyled>
  )
}